import { tokens } from "../../../theme";
import { useState } from "react";
import {
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import { MoreVert } from "@mui/icons-material";
import { useHasPermissionState } from "../../../api/iam";
import { releaseStyles } from "../styles";

// Menu entries backed by an API action are disabled while the permission
// check is in flight, then hidden if the user turns out to lack it.
const PermittedMenuItem = ({ item, onClose }) => {
  const theme = useTheme();
  const { summaryTable } = releaseStyles(tokens(theme.paletteId));

  const { hasPermission, isLoading } = useHasPermissionState(
    item.path,
    "PATCH",
    item.action
  );

  if (!isLoading && !hasPermission) {
    return null;
  }

  return (
    <MenuItem
      sx={summaryTable.menuItem(item.destructive)}
      disabled={isLoading}
      onClick={() => {
        item.onClick();
        onClose();
      }}
    >
      {isLoading ? "Checking permissions…" : item.text}
    </MenuItem>
  );
};

const ActionMenu = ({ items = [], staticItems = [] }) => {
  const theme = useTheme();
  const { summaryTable } = releaseStyles(tokens(theme.paletteId));

  const [anchorEl, setAnchorEl] = useState(null);
  const closeMenu = () => setAnchorEl(null);

  if (!items.length && !staticItems.length) {
    return null;
  }

  return (
    <>
      <Tooltip title={<Typography>More actions</Typography>}>
        <IconButton
          size="small"
          sx={summaryTable.menuButton}
          onClick={(event) => setAnchorEl(event.currentTarget)}
        >
          <MoreVert fontSize="inherit" />
        </IconButton>
      </Tooltip>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={closeMenu}>
        {items.map((item) => (
          <PermittedMenuItem key={item.key} item={item} onClose={closeMenu} />
        ))}
        {staticItems.map((item) => (
          <MenuItem
            key={item.key}
            sx={summaryTable.menuItem(false)}
            onClick={() => {
              item.onClick();
              closeMenu();
            }}
          >
            {item.text}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default ActionMenu;
